"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'LANA FAN CLUB',
    organizationId: 'i7skBsIuhgdw46sbnDxd',
    applicationKey: 'lana',
    applicationType: 'standalone',
    artistId: 'twjFc3Pum2MYqVzXEnlcMUBQ48i2',
    deeplinkUrl: 'https://fc.lanal7.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    deeplinkProd: 'fc.lanal7.com',
    deeplinkStg: 'lana-stg.netlify.app',
    custom: {
        modules: {
            membership: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            resale: true,
            preSale: true,
            event: true,
            cart: true,
            pickup: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'postVideos', 'gallery', 'notifications', 'myProfile'],
    },
});
